import { render } from "./Favorites.vue?vue&type=template&id=dbd2921e"
import script from "./Favorites.vue?vue&type=script&lang=js"
export * from "./Favorites.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Favorites.vue?vue&type=style&index=0&id=dbd2921e&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__